<template>
  <div>
    <el-card>
      <div class="box-card">
        <img :src="hotelInfo.img" alt="" />
        <span class="mt-10 fz">{{ hotelInfo.jdmc }}</span>
        <span class="mt-10 fz">{{ hotelInfo.jdmcEn }}</span>
        <span class="mt-10" style="color: #808080">{{ hotelInfo.address }}</span>
        <el-divider class="divider"></el-divider>
        <div class="room">
          <span>{{ selectRoom.roomName }}</span>
        </div>
        <el-divider class="divider"></el-divider>
        <div class="info-text">
          <span class="info-t-left">支付类型：</span>
          <span>{{ selectRatePlan.payment == 1 ? '现付' : '预付' }}</span>
        </div>
        <div class="info-text">
          <span class="info-t-left">早餐：</span>
          <span>{{ freeMealStr }}</span>
        </div>
        <div class="info-text" v-if="hotelInfo.depositPolicy && hotelInfo.depositPolicy.amount">
          <span class="info-t-left">是否有押金：</span>
          <span>有</span>
        </div>

        <el-divider class="divider0"></el-divider>
        <el-popover placement="bottom" width="500" trigger="hover">
          <div class="hover-info" style="overflow: auto;">
            <div class="td">
              <p style="padding-right: 80px;">入住日</p>
              <p style="text-align: right;">房价*间数</p>
            </div>
            <el-divider class="divider0"></el-divider>
            <div class="td" v-for="item in nightlyRates" :key="item.index">
              <p> {{ item.date }}( {{ filtersTime(item.date) }})</p>
              <p style="text-align: right;">￥{{ item.salePrice }}*{{ htCnParams.roomNum }}<span
                  v-if="(isWbPromptBool || ht20076) && item.isCb" class="red">(超标)</span>
              </p>
            </div>
            <!-- <el-divider class="divider0"></el-divider>
            <div class="info" slot="reference" style="margin-top: 10px;"
              v-if="selectRatePlan.additionalTax && selectRatePlan.additionalTax.localTotalAmount">
              <div class="check-in" style="margin-left: 40px; color: #f99117;">
                到店另付其他税/费&nbsp;&nbsp;{{
                  selectRatePlan.additionalTax.localTotalAmount }}&nbsp;{{
                  currencyObj.quote }}<span v-if="localTotalRateAmount">(￥{{ localTotalRateAmount
                }})</span>
              </div>
            </div> -->

            <div class="info" slot="reference" v-if="showCbje" style="margin-top: 10px;">
              <div class="check-in" style="margin-left: 40px; color: red;">
                本次预订超标金额 &nbsp;&nbsp;<span style="color: red;">￥{{ fillCbje }}</span>
              </div>
            </div>

            <div class="tr">
              <p>服务费：</p>
              <p>¥{{ priceDetail.fee }}</p>
            </div>

            <div class="tr">
              <p>总额：</p>
              <p>¥{{ priceDetail.totalPrice }}<span v-if="totalRatePrice">({{ totalRatePrice }}&nbsp;{{
                currencyObj.quote }})</span></p>
            </div>

            <div class="tr" style="color: #ff9524;" v-if="selectRatePlan.additionalTax && selectRatePlan.additionalTax.localTotalAmount">
              <p>到店另付其他税/费：&nbsp;&nbsp;</p>
              <p>¥{{ selectRatePlan.additionalTax.localTotalAmount }}{{ currencyObj.quote }}</p>
            </div>
          </div>
          <div class="info" slot="reference">
            <div class="check-in" style="width:350px">
              <div class="left">
                <p>
                  <span>入住
                    <p>{{ nightCount }}晚</p>
                  </span>
                </p>
                <p>
                  <span>客房
                    <p>{{ homeRooms }}间</p>
                  </span>
                </p>
              </div>
              <p class="right" style="color: red;">¥{{ priceDetail.totalPrice }}<span style="font-size: 13px;"
                  v-if="totalRatePrice">({{ totalRatePrice }} &nbsp;{{ currencyObj.quote
                  }})</span>
              </p>
            </div>
          </div>
          <div class="info" slot="reference"
            v-if="selectRatePlan.additionalTax && selectRatePlan.additionalTax.localTotalAmount">
            <div class="check-in" style="width:350px; color: #f99117;">
              到店另付其他税/费&nbsp;&nbsp;{{
                selectRatePlan.additionalTax.localTotalAmount }}&nbsp;{{ currencyObj.quote
              }}<span v-if="localTotalRateAmount">(￥{{ localTotalRateAmount
              }})</span>
            </div>
          </div>
        </el-popover>

      </div>
    </el-card>
    <el-card class="card2" style="margin-top: 27px">
      <div class="info" style="padding-left: 0;">
        <span>取消规则</span>
        <span :style="{ color: selectRatePlan.shortRule == 23 ? '#f7613f' : '#1b8cff' }">
          {{ selectRatePlan.prepayRule ? selectRatePlan.prepayRule.cancelRuleDesc : '无取消规则' }}
        </span>
      </div>
      <div class="info" style="padding-left: 0;" v-show="selectRatePlan.bookEquity">
        <span>嘉享权益</span>
        <span>
          {{ selectRatePlan.bookEquity }}
        </span>
      </div>
    </el-card>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { getFreeMealStr } from '../../../hooks/useHotel';
import Arith from '../../../utils/arith';

export default {
  props: {},
  data() {
    return {
      localTotalRateAmount: 0,
      currencyObj: {},
    }
  },
  computed: {
    ...mapState({
      homeRooms: (state) => state.intHt.homeRooms,
      selectRoom: state => state.intHt.selectRoom,
      selectRatePlan: state => state.intHt.selectRatePlan,
      hotelInfo: (state) => state.intHt.hotelInfo,
      servicePrice: (state) => state.intHt.servicePrice,
      isFreeMeal: (state) => state.intHt.isFreeMeal,
      description: (state) => state.intHt.description,
      htCnPolicy: state => state.intHt.htCnPolicy,
      htCnQuery: state => state.intHt.htCnQuery,
      htCnParams: state => state.intHt.htCnParams,
      wbObj: state => state.intHt.wbObj,
    }),
    ...mapGetters({
      getVipParamterByParNo: 'common/getVipParamterByParNo',
      nightlyRates: 'intHt/nightlyRates',
      priceDetail: 'intHt/getPriceDetail',
      nightCount: 'intHt/nightCount',
      fillCbje: 'intHt/fillCbje',
    }),
    // 酒店是否开启单间夜价格二次匹配差标
    ht20076() {
      let param = this.$common.getVipParamterByParNo(this.$store, 20076, 0)
      return param == 1 && this.tripType == 1;
    },
    freeMealStr() {
      if (!this.selectRatePlan) return '-';
      return getFreeMealStr(this.selectRatePlan.freeMeal)
    },
    // 判断是否有超标
    isWbPromptBool() {
      let ht20043 = this.getVipParamterByParNo(20043, 0),
        isWb = ht20043 == 1 && this.tripType == 1 && this.wbObj.isWeibei,
        jdjgbz = this.jdjgbz;
      if (isWb) {
        if (!this.nightlyRates) return false;
        for (let item of this.nightlyRates) {
          if (jdjgbz && jdjgbz < item.salePrice) {
            return true;
          }
        }
      }
      return false;
    },
    showCbje() {
      let show = this.getVipParamterByParNo(20025, 0) == 1 &&
        this.wbObj && this.wbObj.isWeibei &&
        this.tripType == 1 &&
        this.jdjgbz;
      console.log('showCbje === ', show);
      return show;
    },
    jdjgbz() {
      let policy = this.htCnPolicy.policy || {},
        jdjgbz = policy.jdjgbz ? policy.jdjgbz - 0 : '';
      return jdjgbz;
    },
    tripType() {
      return this.htCnQuery.tripType
    },
    gkfs() {
      let policy = this.htCnPolicy.policy || {},
        gkfs = policy.gkfs;
      return gkfs;
    },

    // 超标个人自付-公司支付金额
    compPayAmt() {
      let jy = this.$common.numMulti(this.night, this.homeRooms),
        policy = this.htCnPolicy.policy || {},
        jdjgbz = policy.jdjgbz || 0,
        total = this.$common.numMulti(jdjgbz, jy);
      total = this.$common.addition(total, this.servicePrice);
      if (this.gkfs == 3 && this.$common.addition([this.price, -total]) < 0) {
        return this.price;
      }
      return total;
    },
    // 超标个人自付-个人支付金额
    cbje() {
      var total = this.gkfs == 3 ? this.$common.addition([this.price, -this.compPayAmt]) : 0;
      if (total < 0) return 0;
      return total;
    },
    filtersTime() {
      return function (value) {
        return this.$dateTime.getWeekZhou(value)
      }
    },
    // 转换汇率之后的币种总金额
    totalRatePrice() {
      if (!this.priceDetail || !this.priceDetail.totalPrice || !this.currencyObj || !this.currencyObj.rate) return 0;
      return Arith.thousandBit(Arith.mul(this.priceDetail.totalPrice, this.currencyObj.rate));
    },
  },
  mounted() {
    // console.log(this.selectRoom, 'selectRoom', 'hotelInfo', this.hotelInfo)
    // console.log(this.nightlyRates, 'nightlyRates')
    // console.log(this.priceDetail, 'priceDetail')
    // console.log("wbObj ====== ", this.wbObj)
    this.getCountryCurrencyRate();
  },
  methods: {
    getCountryCurrencyRate() {
      // 每次加载前先清空
      if (!this.hotelInfo?.countryCode) return;
      this.$conn.getConn('intht.countryCurrencyRate')({
        countryCode: this.hotelInfo?.countryCode
      }, (res) => {
        let data = res.data || {};
        this.currencyObj = data;
        if (this.selectRatePlan?.localTotalAmount && data.rate) {
          // 到店付价格转人民币
          this.localTotalRateAmount = Arith.div(this.selectRatePlan?.localTotalAmount, data.rate);
        }
      })
    }
  },
  filters: {
    breakfastTypeName(val = 0) {
      let retStr = '';
      if (val == 1 || val == 2) {
        retStr = val + '份早';
      } else if (val > 2) {
        retStr = '多份早';
      } else {
        retStr = '不含早'
      }
      return retStr
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-popover {
  padding: 0;
}

.divider {
  margin: 20px 0px 15px 0;
}

.divider0 {
  margin: 0px;
}

.info-t-left {
  display: inline-block;
  text-align: left;
  width: 100px;
}

.fz {
  font-weight: bold;
  font-size: 20px;
}

.mt-10 {
  margin-top: 10px;
}

.red {
  color: red;
}

.hover-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .td {
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 50px;
    color: rgb(128, 128, 128);
    align-items: center;
    padding-right: 40px;
    text-align: right;

    p {
      flex: 1;
    }
  }

  .tr {
    width: 100%;
    margin-top: 10px;
    padding-right: 40px;
    display: flex;
    color: red;
    float: right;
    // color: rgb(128, 128, 128);
    text-align: right;
    justify-content: flex-end;
    // p:nth-child(2) {
    // 	color: #ff9524;
    // }
  }
}

.card2 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 15px;
    padding-left: 50px;

    span:nth-child(1) {
      font-weight: bold;
      text-align: left;
    }

    span:nth-child(2) {
      margin-top: 10px;
      color: rgb(128, 128, 128);
      text-align: left;
    }
  }
}

.box-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;

  img {
    width: 100%;
    height: 150px;
  }

  .room {
    display: flex;
    align-items: center;
    font-size: 20px;

    img {
      margin-left: 20px;
      width: 40px;
      height: 25px;
    }
  }

  .info-text {
    margin-bottom: 15px;
  }

  .check-in {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin-top: 20px;

    .left {
      display: flex;

      span {
        display: flex;
        color: #808080;
        margin-right: 10px;

        p {
          color: #000;
        }
      }
    }

    .right {
      font-size: 20px;
      color: #ff9524;
    }
  }
}
</style>